export const warningColorScale = {
    0: "#000000",
    5: "#2D1700",
    10: "#412100",
    15: "#542A00",
    20: "#693500",
    25: "#7E3F00",
    30: "#934A00",
    35: "#7F4300",
    40: "#BD6B1A",
    49: "#AF600D",
    50: "#DE8730",
    55: "#C26F1E",
    60: "#FFA449",
    70: "#FFBE7D",
    80: "#FFD5AB",
    90: "#FFEBD6",
    95: "#FFF5EA",
    98: "#FFFBF7",
    99: "#FFFDFB",
    100: "#FFFFFF",
};
